import { Injectable } from '@angular/core';
import { SafariReduxPageUiObject, defaultPageUiState } from '@safarilaw-webapp/shared/redux';

import { ServingPartyEditPageUiState } from './interface';
import { createSelector } from '@ngrx/store';
import { getSharedFeatureState } from '../../../redux/state.selector';

@Injectable({ providedIn: 'root' })
export class LpmsServingPartyEditPageReduxUiObject extends SafariReduxPageUiObject<ServingPartyEditPageUiState> {
  // Doing this to prevent the compiler from complaining. We will be getting rid of this default
  // thing but this makes it compile for now
  default = {};

  constructor() {
    const getPageState = createSelector(getSharedFeatureState, state => state.pages.servingPartyEditPage);
    super('Lpms', 'Serving Party Edit', getPageState, defaultPageUiState);
  }
}
